



























export default {
  name: 'DynamicImageIcon',
  props: {
    imgUrl:String,
    label:String,
    alt:String
  }

};
